export default {
    list: {
        add: 'Ajouter',
        allTab: 'Toutes',
        bulkAction: 'Actions de masse',
        delete: 'Supprimer',
        deleteModal: {
            message: 'Voulez-vous vraiment supprimer les automatisations sélectionnées?',
            header: 'Suppression d\'automatisations',
        },
        name: 'Nom',
        noAutomations: 'Aucune automatisation trouvée.',
        pageTitle: 'Automatisations',
        pause: 'Suspendre',
        paused: 'Suspendue',
        pausedTab: 'Suspendues',
        run: 'Activer',
        running: 'Active',
        runningTab: 'Actives',
        wouldYouLikeToAddOne: 'Voulez-vous en ajouter une?',
    },
    modal: {
        activeDays: 'Jours actifs',
        advanced: 'Avancé',
        before: 'avant',
        contactPreference: 'Préférence du contact',
        content: 'Contenu',
        day: 'jour | jours',
        dayHeader: 'Jour',
        divergingTimezones: 'Le fuseau horaire de l\'utilisateur est différent de celui du compte. Assurez-vous d\'entrer une heure selon le fuseau horaire du compte.',
        doNotSendAfter: 'Exclure les rendez-vous après...',
        doNotSendBefore: 'Exclure les rendez-vous avant...',
        doNotSendWithMake: 'Exclure les rendez-vous dont la marque du véhicule contient...',
        email: 'Courriel',
        exclusions: 'Exclusions',
        general: 'Général',
        hour: 'heure | heures',
        hourOfDay: 'Heure du jour',
        keywords: 'Mots-clés',
        keywordsDetails: 'Plusieurs valeurs peuvent être inscrites, séparées par une virgule. Insensible à la casse.',
        locale: 'Langue',
        message: 'Message',
        name: 'Nom',
        none: 'Aucune',
        same: 'Même',
        sms: 'SMS',
        subject: 'Objet',
        successMessage: 'Votre automatisation a été créé avec succès.',
        timeDay: 'Heure et journée',
        timeHeader: 'Heure',
        timeOfDay: 'Moment de la journée',
        title: 'Automatisation',
        type: 'Type',
        updateMessage: 'Votre automatisation a été modifiée avec succès.',
        userLinked: 'Utilisateur lié',
        userLinkedHint: "L'automatisation sera envoyée à partir de cet utilisateur",
        week: 'semaine | semaines',
        weekHeader: 'Semaine',
        what: 'Quoi',
        whatTime: 'Quelle heure?',
        when: 'Quand',
        whenAutomationActive: 'Quand cette automatisation est-elle active?',
        whenWillMessageBeSent: 'Quand le message sera-t-il envoyé?',
    },
};
